// extracted by mini-css-extract-plugin
module.exports = {"redlFileTree":"AfegirBloc_redlFileTree__3APsm","redlAfegirBlocImatgeWrapper":"AfegirBloc_redlAfegirBlocImatgeWrapper__5i6b9"};